
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/rate-limit-exceeded",
      function () {
        return require("private-next-pages/docs/errors/rate-limit-exceeded.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/rate-limit-exceeded"])
      });
    }
  